/**
 * Modulo para manejo de componentes en navegador
 */
import {
  BrowserModule,
  HAMMER_GESTURE_CONFIG,
  HammerGestureConfig,
  HammerModule,
} from "@angular/platform-browser";
/**
 * Modulo para controlen la inicializacion de la app
 */
import {
  NgModule,
  APP_INITIALIZER,
  LOCALE_ID,
  Injectable,
  CUSTOM_ELEMENTS_SCHEMA
} from "@angular/core";

/**
 * Modulo para manejo de de formularios
 */
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
/**
 * Modulo para manejo de redireccionamiento
 */
import { AppRoutingModule } from "./app-routing.module";
/**
 * Componente padre e inicializa la app
 */
import { AppComponent } from "./app.component";
/**
 * Servicio para manejo del storage
 */
import { StorageService } from "./services/storage.service";
/**
 * Servicio principal comun
 */
import { MainService } from "./services/main.service";
/**
 * servicio para inciializacion de pago
 */
import { CreatePaymentOrderService } from "./services/api/create-payment-order.service";
/**
 * servicio de manejo de spinner
 */
import { SpinnerAlertService } from "./services/spinner-alert.service";
/**
 * servicio para control de token
 */
import { TokenService } from "./services/token.service";
/**
 * manejo de peticiones http
 */
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
/**
 * componente para manejo de spinner
 */
import { SpinnerComponent } from "./components/medley/spinner/spinner.component";
/**
 *Interceptor para manejo de headers
 */
import { HeaderInterceptor } from "./interceptors/header-interceptor";
/**
 * *Interceptor para manejo de respuesta de servicios
 */
import { ResponseInterceptor } from "./interceptors/response-interceptor";
/**
 * * * componente para manejo de pantalla de comporbante de operacion
 */
import { TicketComponent } from "./views/compra/ticket/ticket.component";
/**
 * * * componente para manejo de pantalla de ingreso de datos
 */
import { CapturaComponent } from "./views/compra/captura/captura.component";

import { environment } from "../environments/environment";

/**
 * Servicio con respeusta de cuentas por usuario
 */
import { CryptoService } from "./services/crypto.service";
import { CatalogosService } from "./services/catalogos.service";
import { DeviceInfoService } from "./services/device-info.service";
import {
  CurrencyPipe,
  DatePipe,
  NgOptimizedImage,
  registerLocaleData,
  TitleCasePipe,
} from "@angular/common";

import localeMx from "@angular/common/locales/es-MX";
import { TelephoneCompaniesComponent } from "./components/telephone-companies/telephone-companies.component";
import { TopBarComponent } from "./components/top-bar/top-bar.component";
import { SelectAccountComponent } from "./components/select-account/select-account.component";
import { CellPhoneDirectoryComponent } from "./components/cell-phone-directory/cell-phone-directory.component";
import { DialogBottomSheetOverview } from "./components/dialogs/ammount/dialog-amount.component";
registerLocaleData(localeMx, "esMx");
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgxMaskModule } from "ngx-mask";
import { AccountsListComponent } from "./components/accounts-list/accounts-list.component";
import { CardDialog } from "./components/dialogs/cards/dialog-card.component";
import { InsufficientFundsDialog } from "./components/dialogs/insufficient-funds/dialog-insufficient-funds.component";
import { ENV_CONFIG } from "./tokens/environment-config.token";
import { DialogConsiderationComponent } from "./components/dialog-consideration/dialog-consideration.component";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { GoPayCommonsService } from "./services/go-pay-commons.service";
import { AppLoadService } from "./services/app-load.service";
import { SelectAmountComponent } from "./components/select-amount/select-amount.component";
import { AlertService } from "./services/alert.service";
import { RetrieveCardsByUserService } from "./services/api/retrieve-cards-by-user.service";
import { FallbackSourceDirective } from "./directives/fallback-source.directive";
import {
  FlameTheme,
  FlameThemeService,
  FlameThemeModule,
} from "@ngx-mxflame/atoms/theme";
import { FlameButtonModule } from '@ngx-mxflame/atoms/button';
import { FlameIconModule } from '@ngx-mxflame/atoms/icon';
import { FlameSlideButtonModule } from '@ngx-mxflame/atoms/slide-button';
import { FlameAvatarModule } from '@ngx-mxflame/atoms/avatar';
import { FlameBottomSheetModule } from '@ngx-mxflame/atoms/bottom-sheet';
import { FlameInputModule } from '@ngx-mxflame/atoms/input';
import { FlameFormFieldModule } from '@ngx-mxflame/atoms/form-field';
import { FlameEmptyStateModule } from '@ngx-mxflame/atoms/empty-state';
import { FlameListCardModule } from '@ngx-mxflame/molecules/list-card';
import { FlameCardModule } from '@ngx-mxflame/atoms/card';
import { FlameChipModule } from '@ngx-mxflame/atoms/chip';
import { FlameCardNumberModule } from '@ngx-mxflame/pipes/card-number';


// particular imports for hammer
import * as Hammer from "hammerjs";

/**
 * Se lee ambiente antes de iniciarlizar acceso a componentes
 * @param appLoadService
 */
export function get_settings(appLoadService: AppLoadService) {
  return () => appLoadService.getSettings();
}

@Injectable()
export class CustomHammerConfig extends HammerGestureConfig {
  overrides = {
    swipe: { direction: Hammer.DIRECTION_ALL },
    pinch: { enable: false },
    rotate: { enable: false }
  };
}

import "hammerjs";
import { DialogErrorComponent } from "./components/dialog-error/dialog-error.component";
import { CompaniesComponent } from './views/compra/companies/companies.component';
import { CellPhoneMaskDirective } from "./directives/cell-phone-mask.directive";
import { HistoryComponent } from './views/compra/history/history.component';
import { BasicCardComponent } from './components/basic-card/basic-card.component';
import { PhonePipe } from './pipes/phone/phone.pipe';
import { PictureComponent } from "./components/picture/picture.component";
import { PanelScheduleComponent } from './components/panel-schedule/panel-schedule.component';
import { RechargeSchedulesComponent } from "./components/recharge-schedules/recharge-schedules.component";
import { TaFlameCalendarModule } from "./components/calendar/calendar.module";
import { SheetDeactivateComponent } from './components/sheet-deactivate/sheet-deactivate.component';

/**
 * Importacion de modulos
 */
@NgModule({ declarations: [
        AppComponent,
        SpinnerComponent,
        CapturaComponent,
        TicketComponent,
        TelephoneCompaniesComponent,
        TopBarComponent,
        SelectAccountComponent,
        CellPhoneDirectoryComponent,
        DialogBottomSheetOverview,
        CardDialog,
        AccountsListComponent,
        InsufficientFundsDialog,
        DialogConsiderationComponent,
        DialogErrorComponent,
        SelectAmountComponent,
        FallbackSourceDirective,
        CompaniesComponent,
        FallbackSourceDirective,
        CellPhoneMaskDirective,
        HistoryComponent,
        BasicCardComponent,
        PhonePipe,
        PictureComponent,
        PanelScheduleComponent,
        RechargeSchedulesComponent,
        SheetDeactivateComponent
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [BrowserAnimationsModule,
        BrowserModule,
        ReactiveFormsModule,
        FormsModule,
        AppRoutingModule,
        NgxMaskModule.forRoot(),
        NgxSkeletonLoaderModule.forRoot(),
        HammerModule,
        NgOptimizedImage,
        FlameThemeModule.forRoot({
            themes: [FlameTheme],
            default: FlameTheme
        }),
        FlameButtonModule,
        FlameIconModule,
        FlameSlideButtonModule,
        FlameAvatarModule,
        FlameBottomSheetModule,
        FlameInputModule,
        FlameFormFieldModule,
        FlameEmptyStateModule,
        FlameListCardModule,
        FlameCardModule,
        FlameChipModule,
        FlameCardNumberModule,
        TaFlameCalendarModule], providers: [
        StorageService,
        MainService,
        AlertService,
        CreatePaymentOrderService,
        AppLoadService,
        SpinnerAlertService,
        TokenService,
        RetrieveCardsByUserService,
        CryptoService,
        CatalogosService,
        DeviceInfoService,
        GoPayCommonsService,
        TitleCasePipe,
        FlameThemeService,
        DatePipe,
        CurrencyPipe,
        { provide: LOCALE_ID, useValue: "esMX" },
        { provide: HTTP_INTERCEPTORS, useClass: HeaderInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ResponseInterceptor, multi: true },
        {
            provide: APP_INITIALIZER,
            useFactory: get_settings,
            deps: [AppLoadService],
            multi: true,
        },
        {
            provide: HAMMER_GESTURE_CONFIG,
            useClass: CustomHammerConfig,
        },
        {
            provide: ENV_CONFIG,
            useValue: environment,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })

/**
 * Clase controladora de la aplicacion con la que se importan componentes, servicios y features
 */
export class AppModule {}
